const Wdata=[
    {
    "id": 1,
    "img":"https://demo.tagdiv.com/newspaper_black_pro/wp-content/uploads/2019/11/18-485x360.jpg",
    "title": "Tesla’s Cybertruck fiasco cost Elon Musk $768 million in a single day",
     "description":"Last week, news broke that James Dean will star in a new movie—64 years after his death.",
    "category": "1",
    },
    {
    "id": 2,
    "img":"https://demo.tagdiv.com/newspaper_black_pro/wp-content/uploads/2019/11/28-485x360.jpg",
    "title": "The future of possible innovation for business company.",
     "description":"Last week, news broke that James Dean will star in a new movie—64 years after his death.",
    "category": "2",
    },
    {
    "id": 3,
    "img":"https://demo.tagdiv.com/newspaper_black_pro/wp-content/uploads/2019/11/29-485x360.jpg",
    "title": "These striking photos capture the future of human flight",
     "description":"Last week, news broke that James Dean will star in a new movie—64 years after his death.",
    "category": "3",
    },
    {
        "id": 4,
        "img":"https://demo.tagdiv.com/newspaper_black_pro/wp-content/uploads/2019/11/13-485x360.jpg",
        "title": "What’s the point of ‘Charlie’s Angels’ without Sam Rockwell dancing?",
         "description":"Last week, news broke that James Dean will star in a new movie—64 years after his death..",
        "category": "4",
        },
        {
            "id": 5,
            "img":"https://demo.tagdiv.com/newspaper_black_pro/wp-content/uploads/2019/11/14-485x360.jpg",
            "title": "Substituting ‘follow your passion’ with ‘find your purpose’",
             "description":"Last week, news broke that James Dean will star in a new movie—64 years after his death. A production company called Magic City got...",
            "category": "5",
            },
            {
            "id": 6,
            "img":"https://demo.tagdiv.com/newspaper_black_pro/wp-content/uploads/2019/11/15-485x360.jpg",
            "title": "8 things millennials wish you would just stop getting them for the holidays",
             "description":"Last week, news broke that James Dean will star in a new movie—64 years after his death. A production company called Magic City got...",
            "category": "6",
            },
            {
            "id": 7,
            "img":"https://demo.tagdiv.com/newspaper_black_pro/wp-content/uploads/2019/11/16-485x360.jpg",
            "title": "Practicing gratitude regularly can make you less stressed and sleep better",
            "description":"Last week, news broke that James Dean will star in a new movie—64 years after his death. A production company called Magic City got...",
            "category": "7",
            },
            {
                "id": 8,
                "img":"https://html.dynamiclayers.net/dl/news24/img/entertain-8.jpg",
                "title": "26 last-minute holiday gifts that are still thoughtful and unique",
                "description":"Last week, news broke that James Dean will star in a new movie—64 years after his death. A production company called Magic City got...",
                "category": "8",
                },
]
export default Wdata;